import React, { useState, useEffect } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Box,
  useTheme
} from "@mui/material"
import { DragIndicator, Close } from "@mui/icons-material"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import AppButton from "components/StyledComponents/AppButton"

const ReorderCategoriesModal = ({ open, onClose, categories, onSave }) => {
  const [localCategories, setLocalCategories] = useState([])
  const theme = useTheme()

  useEffect(() => {
    if (open) {
      setLocalCategories([...(categories || [])])
    }
  }, [open, categories])

  const onDragEnd = (result) => {
    if (!result.destination) return
    if (result.source.index === result.destination.index) return
    const next = Array.from(localCategories)
    const [moved] = next.splice(result.source.index, 1)
    next.splice(result.destination.index, 0, moved)
    setLocalCategories(next)
  }

  const handleSave = () => {
    onSave(localCategories)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: theme.palette.background.default,
          borderRadius: "12px",
          backgroundImage: "none"
        }
      }}>
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
        <Typography variant="h6">Reorder Categories</Typography>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: theme.palette.text.primary,
            position: "absolute",
            top: "15px",
            right: "15px",
            zIndex: 10,
            backgroundColor: theme.palette.background.main
          }}>
          <Close sx={{ height: 14, width: 14 }} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="category-reorder">
            {(provided) => (
              <List {...provided.droppableProps} ref={provided.innerRef}>
                {localCategories.map((cat, index) => (
                  <Draggable
                    key={String(cat.food_category_id)}
                    draggableId={String(cat.food_category_id)}
                    index={index}>
                    {(provided, snapshot) => (
                      <ListItem
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        sx={{
                          backgroundColor: snapshot.isDragging
                            ? theme.palette.drawer?.main || theme.palette.action.hover
                            : "transparent",
                          mb: 0.5,
                          borderRadius: "8px",
                          mx: 1,
                          width: "auto"
                        }}>
                        <ListItemIcon {...provided.dragHandleProps}>
                          <DragIndicator sx={{ color: theme.palette.text.secondary }} />
                        </ListItemIcon>
                        <ListItemText
                          primary={cat.food_category}
                          sx={{ color: theme.palette.text.primary }}
                        />
                      </ListItem>
                    )}
                  </Draggable>
                ))}
                {provided.placeholder}
              </List>
            )}
          </Droppable>
        </DragDropContext>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
          <AppButton onClick={onClose} style={{ padding: "10px 24px" }}>
            Cancel
          </AppButton>
          <AppButton onClick={handleSave} style={{ padding: "10px 24px" }}>
            Save
          </AppButton>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ReorderCategoriesModal
